import React from 'react';
import { InstallationType, useInstallationForm, useProductInCart, useBroadbandStore } from '@sky-tv-group/shared';
import { FormElement, SiteAccessInformation, Progression } from '@sky-tv-group/components';

import { next, back } from './transition';
import { configService, prequalService, serviceProviderService } from '../../services';
import { useCheckoutManager } from '../../hooks/useCheckoutManager';
import { SkyBroadbandForm } from '../../components/checkout';

const BroadbandInstallation = () => {
  const { selfInstallInCart } = useProductInCart();
  const { customerDetails } = useCheckoutManager();
  const installationType = selfInstallInCart ? InstallationType.SelfInstall : InstallationType.BYOD;

  const {
    form,
    fields,
    prequalData,
    providers,
    installDates,
    activationDates,
    isShowSiteAccessInfo,
    siteAccessInformationFields,
  } = useInstallationForm(configService, prequalService, serviceProviderService, installationType, customerDetails);
  const isFibreSwap = prequalData?.isFibreSwapJourney();
  const goNext = async () => {
    form.validate();
    await form.submit();
    if (form.valid) next();
  };


  return (
    <div className="container m-auto md:pb-10 text-primary-mid-night">
      <FormElement {...form.props}>
        <SkyBroadbandForm
          form={form}
          fields={fields}
          isFibreSwap={isFibreSwap ?? false}
          isNotIntactOnt={!prequalData?.isIntactONTJourney()}
          isNotChorus={!prequalData?.isChorus()}
          isNewFibre={prequalData?.isNewFibreJourney() ?? false}
          isSelfInstall={selfInstallInCart}
          consentRequired={prequalData?.consentRequired() ?? false}
          isLfcDoesntTellUsIfConsentRequired={prequalData?.isLfcDoesntTellUsIfConsentRequired() ?? false}
          providers={providers}
          installDates={installDates}
          activationDates={activationDates}
        />
        {isShowSiteAccessInfo && <SiteAccessInformation form={form} fields={siteAccessInformationFields} />}
        <Progression next={goNext} back={back} disableSubmit={false} />
      </FormElement>
    </div>
  );
};

export { BroadbandInstallation };
